import dynamic from 'next/dynamic'

export const NineBlockGrid = dynamic(() => import('./nine-block-grid'))
